import { writable, type Writable } from "svelte/store"

export const localStream: Writable<MediaStream> = writable(null)
